import IconRemove from '../../components/icons/IconRemove';
import language from '../../variables/language';
import usePersistedState from '../../hooks/usePersistedState';

function SessionRow({ session, onDelete }) {
  const lang = language[language.lang];
  return (
    <li className="session-row">
      <div className="session-row-main">
        <span className="session-row-activity">{session.lastActivity}</span>
        <span className="session-row-timezone">{session.timezone}</span>
      </div>
      <span className="session-row-remove" onClick={() => onDelete(session.id)}>
        <IconRemove />
      </span>
    </li>
  );
}

export default function SessionGroupRow({ group, onDelete }) {
  const [expanded, setExpanded] = usePersistedState('session-group-expanded-' + group.label, false);
  const single = group.sessions.length === 1;

  return (
    <li className="session-group">
      <div className="session-group-header" onClick={() => !single && setExpanded((v) => !v)}>
        <span className={'session-group-label' + (single ? '' : ' session-group-label-clickable')}>
          {group.label}
          {!single ? <span className="session-group-expand-hint">{expanded ? '▲' : '▼'}</span> : ''}
        </span>
        {!single ? <span className="session-group-count-badge">×{group.sessions.length}</span> : ''}
        {single ? (
          <span className="session-row-remove" onClick={() => onDelete(group.sessions[0].id)}>
            <IconRemove />
          </span>
        ) : (
          ''
        )}
      </div>
      {!single && expanded ? (
        <ul className="session-group-sessions">
          {group.sessions.map((session) => (
            <SessionRow key={session.id} session={session} onDelete={onDelete} />
          ))}
        </ul>
      ) : (
        ''
      )}
    </li>
  );
}
